// Footer.jsx
// Shared footer for the portal home, per-project pages, and /docs.
// Links are absolute so the footer behaves identically regardless of which
// domain it's rendered on (tk.tripleco.com, datamvps.tripleco.com, or a
// project subdomain) -- same convention as the existing cross-domain nav
// links (e.g. the "Docs" link added to every project's header).

export default function Footer() {
  return (
    <div style={{ marginTop: 48, padding: "16px 0", borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 11, color: "#6b7280" }}>
      <div>TrapperKeeper · Triple Crown Consulting</div>
      <div style={{ display: "flex", gap: 16 }}>
        <a href="https://tk.tripleco.com" style={{ color: "#6b7280", textDecoration: "none" }}>Home</a>
        <a href="https://tk.tripleco.com/docs" style={{ color: "#6b7280", textDecoration: "none" }}>Docs</a>
      </div>
    </div>
  );
}
